import classNames from 'classnames';
import React from "react";

import styles from './PrimaryHeading.module.css'

const PrimaryHeading = ({className, children, ...props}) => {
    return <header className={classNames(styles.header, className)} {...props}>{children}</header>
}

export default PrimaryHeading;